<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CEpbwV/tc-custom/9781418571290.jpg?1717877921008" alt="This image is the cover for the book Complete Life's Little Instruction Book"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Complete Life's Little Instruction Book
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Wouldn’t it be great if someone could download a lifetime of good old-fashioned common sense into one little book? H. Jackson Brown’s <i>The Complete Life’s Little Instruction Book</i> is just that. Solid advice for living well laid out in concise nuggets of wisdom. It contains the 1,560 entries found in all three volumes of the <i>New York Times</i> bestselling Life's Little Instruction Book series. </b></p><p>The Life’s Little Instruction Book series has sold more than ten million copies, spent more than two years atop the <i>New York Times</i> bestseller list, and has been translated into 33 languages—a true example of a giftable book that keeps on giving.</p><p>In this beautiful book, you’ll find such tips as:</p>Say “thank you” a lot.Sing in the shower.Learn to make great chili.Have a firm handshake.<p>This a handsome gift ideal for graduations, birthdays, and holidays.</p><p>“Most of us already know how to live a successful and purposeful life,” says the author. “We know we should be understanding and thoughtful, responsible, courageous, and appreciative. It's just that we sometimes need reminding.” <i>The Complete <i>Life's Little Instruction Book</i></i> is that reminder.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Jackson Brown
      </h2>
      
      <p class="authorDescription body article"><P>&#160;A New York Times best-selling author, H. Jackson Brown&rsquo;s publications are universal in appeal, with more than 30 million copies in print, available in 35 languages. His 33 books inspire readers throughout the world. He lives in Nashville, Tennessee.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4981175a